import React, { Component } from 'react';
import * as Fa from 'react-icons/lib/fa';
import Letter from '../../../../../services/Letter';
import Spinner from '../../../../../components/Spinner';
import Pagination from '../../../../../components/Pagination';
import date from 'date-fns';
import dateLocaleId from 'date-fns/locale/id';
import stripTags from '../../../../../utils'

const LetterService = new Letter();

export default class ProcessingFinalized extends Component {
  state = {
    page: 1,
    limit: 10,
    total: 0,
    pagination: [],
    data: [],
    loading: false,
    searchString: '',
  }


  componentDidMount = () => {
    this.setState({ loading: true }, () => {
      LetterService.getList({ box: 'FINALIZED', page: 1, limit: 10, search: this.state.searchString })
        .then((result) => {
          for (let i in result.data) {
            const signers = result.data[i].signers
            let signer = ""
            if (signers !== null && signers !== undefined && signers && signers.length > 0) {
              signer = signers.pop().split('|').splice(1, 2).join(" | ")
            }
            result.data[i].signer = signer
          }
          this.setState({
            page: result.page,
            limit: result.limit,
            total: result.total,
            data: result.data,
            loading: false,
          });
        })
        .catch((err) => {
          this.setState({
            data: [],
            loading: false,
          });
        });
    });
  }

  page = (page) => {
    this.setState({ loading: true });
    let opt = { box: 'FINALIZED', page: page, limit: this.state.limit, search: this.state.searchString }
    LetterService.getList(opt)
      .then((result) => {
        for (let i in result.data) {
          const signers = result.data[i].signers
          let signer = ""
          if (signers !== null && signers !== undefined && signers && signers.length > 0) {
            signer = signers.pop().split('|').splice(1, 2).join(" | ")
          }
          result.data[i].signer = signer
        }
        this.setState({
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  next = () => {
    this.setState({ loading: true });
    let opt = { box: 'FINALIZED', page: this.state.page + 1, limit: this.state.limit, search: this.state.searchString }
    LetterService.getList(opt)
      .then((result) => {
        for (let i in result.data) {
          const signers = result.data[i].signers
          let signer = ""
          if (signers !== null && signers !== undefined && signers && signers.length > 0) {
            signer = signers.pop().split('|').splice(1, 2).join(" | ")
          }
          result.data[i].signer = signer
        }
        this.setState({
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  prev = () => {
    this.setState({ loading: true });
    let opt = { box: 'FINALIZED', page: this.state.page - 1, limit: this.state.limit, search: this.state.searchString }
    LetterService.getList(opt)
      .then((result) => {
        for (let i in result.data) {
          const signers = result.data[i].signers
          let signer = ""
          if (signers !== null && signers !== undefined && signers && signers.length > 0) {
            signer = signers.pop().split('|').splice(1, 2).join(" | ")
          }
          result.data[i].signer = signer
        }
        this.setState({
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  reload = () => {
    this.setState({ loading: true });
    let opt = { letterType: this.props.type, page: this.state.page, limit: this.state.limit, box: "FINALIZED", search: this.state.searchString }
    LetterService.getList(opt)
      .then((result) => {
        for (let i in result.data) {
          const signers = result.data[i].signers
          let signer = ""
          if (signers !== null && signers !== undefined && signers && signers.length > 0) {
            signer = signers.pop().split('|').splice(1, 2).join(" | ")
          }
          result.data[i].signer = signer
        }
        this.setState({
          currentLetter: {},
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data || [],
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  search = () => {
    this.reload()
  }

  dismissSearch = () => {
    this.setState({ searchString: '' }, () => {
      this.reload()
    });
  }

  handleSearchString = (e) => {
    if (e && e.target && e.target.value) {
      console.log(e.target.value);
      this.setState({ searchString: e.target.value });
    }
  }

  read = (letter) => {
    console.log(letter.id);
    window.browserHistory.push('/read/' + letter.id + '?action=finalized');
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <h4>Surat yang sudah difinalisasi</h4>
          <div className="box box-success">
            <div className="box-body" style={{ padding: 0 }}>
              <div className="row" style={{ padding: 15 }}>
                <div className="col-sm-12 col-md-6 col-lg-8">
                  <div className="input-group input-group-sm">
                    <span className="input-group-btn">
                      <span className="btn btn-success">
                        <Fa.FaRefresh />
                      </span>
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.handleSearchString}
                      value={this.state.searchString}
                      onKeyPress={(e) => { if (e.key === 'Enter') this.search() }}
                    />
                    {this.state.searchString && this.state.searchString.length > 0 &&
                      <span className="input-group-btn">
                        <span className="btn btn-default" onClick={this.dismissSearch}>
                          <Fa.FaClose />
                        </span>
                      </span>
                    }
                    <span className="input-group-btn">
                      <span className="btn btn-default" onClick={this.search}>
                        <Fa.FaSearch />
                      </span>
                    </span>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4">
                  <div style={{ float: 'right' }}>
                    <Pagination
                      disabled={this.state.loading}
                      page={this.state.page}
                      limit={this.state.limit}
                      total={this.state.total}
                      prev={this.prev} next={this.next}
                      toPage={this.page} />
                  </div>
                </div>
                <hr />
              </div>
              {this.state.loading ? <Spinner /> :
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Nomor surat</th>
                      <th>Kepada</th>
                      <th>Perihal</th>
                      <th>Tanggal finalisasi</th>
                      <th>Penanda tangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data && Object.keys(this.state.data).map((item, index) => {
                      return <tr key={index} onClick={() => { this.read(this.state.data[item]) }} style={{ cursor: 'pointer' }}>
                        <td>{this.state.data[item].number}</td>
                        <td>
                          {this.state.data[item].recipients && this.state.data[item].recipients.map((recItem, recIndex) => {
                            if (recItem.recipientType.indexOf('VIA') > -1 ||
                                recItem.recipientType.indexOf('ASSISTANT') > -1 ||
                                recItem.recipientType.indexOf('DELEGATION') > -1 ||
                                recItem.recipientType.indexOf('FORWARD') > -1
                            ) {
                                return '';
                            } else {
                                return <span key={recIndex}>{recItem.recipientName}, </span>
                            }
                          })}
                        </td>
                        <td>{stripTags(this.state.data[item].subject)}</td>
                        <td>
                          {date.format(this.state.data[item].timestamp, 'DD MMMM YYYY', { locale: dateLocaleId })}
                        </td>
                        <td>
                          {this.state.data[item].letterType !== 'TNDE_MEMO' && this.state.data[item].processings && this.state.data[item].processings.length > 0 && this.state.data[item].processings[this.state.data[item].processings.length - 1].holderName.split('|')[0]}
                          {this.state.data[item].letterType === 'TNDE_MEMO' && this.state.data[item].originatorTitle}
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              }
              {!(this.state.total > 0) && !this.state.loading &&
                <div style={{ textAlign: 'center', marginTop: 50, marginBottom: 50 }}>
                  <span style={{ fontSize: 32 }}>
                    <Fa.FaInbox />
                  </span>
                  <br />
                  <h4>Tidak ada surat</h4>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
